import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { environment, JSON_HEADER } from '@asambleas-env/environment';
import { Role } from '@asambleas-models/role.model';

@Injectable()
export class LoginService {

    ingresoUsuario: EventEmitter<any> = new EventEmitter();

    highestRolData: Role;
    highestRol: number = null;

    // Se crea un subject para instanciar un observable
    private subLogged = new Subject<any>();
    public $obsLogged = this.subLogged.asObservable();

    constructor(
        public http: HttpClient,
        private router: Router
    ) {
        console.log('Login Service Constructor')
    }

    public loginUser(credentials) {
        let headers = JSON_HEADER;
        return this.http.post(environment.apiEndPoint + '/usuarios/login', credentials, { headers });
    }

    getUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    getHighestRol(): number {
        if (!this.isLogin()) {
            return null;
        }
        let user = this.getUser();
        let levelRoles: number[] = [];
        for (let i = 0; i < user.roles.length; i++) {
            levelRoles.push(user.roles[i].level);
        }
        let highestRol = null;
        let aux = 0;
        levelRoles.forEach((value) => {
            if (!highestRol) {
                this.highestRolData = user.roles[aux];
                highestRol = value;
            }

            if (value < highestRol) {
                this.highestRolData = user.roles[aux];
                highestRol = value;
            }
            aux++;
        })
        this.highestRol = highestRol;
        return parseInt(highestRol);
    }

    getInfoRole(): Role {
        //console.log(this.highestRolData);
        return this.highestRolData;
    }

    isLogin() {
        let isLogged = localStorage.getItem('user') !== null && localStorage.getItem('id_token') !== null;
        this.subLogged.next(isLogged);
        return isLogged
    }

    signOut() {
        this.highestRol = null;
        localStorage.clear();
        this.isLogin()
        this.router.navigate(['']);
    }

    /**
     * Envia un correo electronico para restaurar la clave acceso del usuario
     */
    sendRestorationPasswordMail(mail: Object) {
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        };

        return this.http.post(
            environment.apiEndPoint + '/usuarios/recuperar-pass',
            mail,
            { headers });
    }

}

export interface LoginUserRs {
    id_token: string
    user: {
        birthdate: string
        birthplace: string
        civil_status: string
        created_at: string
        document_number: string
        document_type: string
        email: string
        gender: string
        id: number
        is_academic: boolean
        name: string
        residence_address: string
        residence_city: string
        second_name: string
        second_surname: string
        surname: string
        updated_at: string
    }
}



// WEBPACK FOOTER //
// ./src/app/services/login/login.service.ts